import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, TextField } from '@mui/material';

function GitHubFields({ instanceUrl, setInstanceUrl, error }) {
  const msg = error?.instanceUrl || '';
  const isError = Boolean(msg);

  return (
    <Box mb={3}>
      <Typography variant="body2" sx={{ fontWeight: 500 }} mb={1}>
        GitHub Instance URL
      </Typography>

      <TextField
        fullWidth
        placeholder="e.g. https://api.github.com"
        value={instanceUrl}
        onChange={(e) => setInstanceUrl(e.target.value)}
        error={isError}
        helperText={msg}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
            transition: 'all 0.2s ease-in-out',
            height: 36,

            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e5e7eb',
              borderWidth: '0.5px',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d1d5db',
              borderWidth: '0.5px',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#5965A6',
              borderWidth: '0.6px',
            },
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ef4444',
              borderWidth: '0.6px',
            },
          },
          '& .MuiInputBase-input': {
            padding: '10px 14px',
            fontSize: '0.9rem',
            fontWeight: 400,
            color: '#374151',
          },
          '& .MuiFormHelperText-root.Mui-error': {
            color: '#ef4444',
            fontSize: '0.75rem',
            marginTop: 0.5,
          },
        }}
      />
    </Box>
  );
}

GitHubFields.propTypes = {
  instanceUrl: PropTypes.string.isRequired,
  setInstanceUrl: PropTypes.func.isRequired,
  error: PropTypes.object.isRequired, // { instanceUrl?: string }
};

export default GitHubFields;

